var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "角色名称",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入角色名称查询",
                                    },
                                    model: {
                                      value: _vm.queryParam.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "name", $$v)
                                      },
                                      expression: "queryParam.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "备注",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入备注查询" },
                                    model: {
                                      value: _vm.queryParam.description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新增")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "delete" },
                          on: { click: _vm.batchDel },
                        },
                        [_vm._v("删除")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "check-square" },
                          on: {
                            click: function ($event) {
                              return _vm.batchSetStatus(true)
                            },
                          },
                        },
                        [_vm._v("启用")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "close-square" },
                          on: {
                            click: function ($event) {
                              return _vm.batchSetStatus(false)
                            },
                          },
                        },
                        [_vm._v("禁用")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "a-table",
                    {
                      ref: "table",
                      attrs: {
                        size: "middle",
                        bordered: "",
                        rowKey: "id",
                        columns: _vm.columns,
                        dataSource: _vm.dataSource,
                        pagination: _vm.ipagination,
                        scroll: _vm.scroll,
                        loading: _vm.loading,
                        rowSelection: {
                          selectedRowKeys: _vm.selectedRowKeys,
                          onChange: _vm.onSelectChange,
                        },
                      },
                      on: { change: _vm.handleTableChange },
                      scopedSlots: _vm._u([
                        {
                          key: "action",
                          fn: function (text, record) {
                            return _c(
                              "span",
                              {},
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSetFunction(record)
                                      },
                                    },
                                  },
                                  [_vm._v("分配菜单")]
                                ),
                                _c("a-divider", {
                                  attrs: { type: "vertical" },
                                }),
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSetPushBtn(
                                          record.id,
                                          record.name
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("分配按钮")]
                                ),
                                _c("a-divider", {
                                  attrs: { type: "vertical" },
                                }),
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(record)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _vm.btnEnableList.indexOf(1) > -1
                                  ? _c("a-divider", {
                                      attrs: { type: "vertical" },
                                    })
                                  : _vm._e(),
                                _vm.btnEnableList.indexOf(1) > -1
                                  ? _c(
                                      "a-popconfirm",
                                      {
                                        attrs: { title: "确定删除吗?" },
                                        on: {
                                          confirm: () =>
                                            _vm.handleDelete(record.id),
                                        },
                                      },
                                      [_c("a", [_vm._v("删除")])]
                                    )
                                  : _vm._e(),
                                _c(
                                  "a-modal",
                                  {
                                    attrs: { title: "操作提示" },
                                    on: { ok: _vm.handleRoleTip },
                                    model: {
                                      value: _vm.roleModalVisible,
                                      callback: function ($$v) {
                                        _vm.roleModalVisible = $$v
                                      },
                                      expression: "roleModalVisible",
                                    },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v("保存角色已经操作成功！现在继续"),
                                      _c("b", [_vm._v("分配菜单")]),
                                      _vm._v("吗？"),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            )
                          },
                        },
                        {
                          key: "customRenderFlag",
                          fn: function (enabled) {
                            return [
                              enabled
                                ? _c("a-tag", { attrs: { color: "green" } }, [
                                    _vm._v("启用"),
                                  ])
                                : _vm._e(),
                              !enabled
                                ? _c("a-tag", { attrs: { color: "orange" } }, [
                                    _vm._v("禁用"),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "typeTitle" }, slot: "typeTitle" },
                        [
                          _vm._v("\n            数据类型\n            "),
                          _c(
                            "a-tooltip",
                            {
                              attrs: {
                                title:
                                  "1、全部数据-该角色对应的用户可以看到全部单据；2、本部门数据-该角色对应的用户可以看到自己所在部门的全部单据；\n              3、个人数据-该角色对应的用户只可以看到自己的单据。单据是指采购入库、销售出库等",
                              },
                            },
                            [
                              _c("a-icon", {
                                attrs: { type: "question-circle" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          attrs: { slot: "priceLimitTitle" },
                          slot: "priceLimitTitle",
                        },
                        [
                          _vm._v("\n            价格屏蔽\n            "),
                          _c(
                            "a-tooltip",
                            {
                              attrs: {
                                title:
                                  "价格屏蔽支持多选，可以对首页和单据进行价格屏蔽，还可以对商品库存和进销存统计报表进行成本价屏蔽",
                              },
                            },
                            [
                              _c("a-icon", {
                                attrs: { type: "question-circle" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("role-modal", {
                ref: "modalForm",
                on: { ok: _vm.roleModalFormOk },
              }),
              _c("role-function-modal", {
                ref: "roleFunctionModal",
                on: { ok: _vm.roleFunctionModalFormOk },
              }),
              _c("role-push-btn-modal", {
                ref: "rolePushBtnModal",
                on: { ok: _vm.modalFormOk },
              }),
              _c(
                "a-modal",
                {
                  attrs: { title: "操作提示" },
                  on: { ok: _vm.handleRoleFunctionTip },
                  model: {
                    value: _vm.roleFunctionModalVisible,
                    callback: function ($$v) {
                      _vm.roleFunctionModalVisible = $$v
                    },
                    expression: "roleFunctionModalVisible",
                  },
                },
                [
                  _c("p", [
                    _vm._v("分配菜单已经操作成功！现在继续"),
                    _c("b", [_vm._v("分配按钮")]),
                    _vm._v("吗？"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }